export const fareExplanationEn: Record<string, string> = {
  "Fare Calculation Explained": "Fare Calculation Explained",
  "Our AI analyzes multiple factors to suggest a fair price for your ride":
    "Our AI analyzes multiple factors to suggest a fair price for your ride",
  "Your Selected Fare": "Your Selected Fare",
  "Suggested by AI": "Suggested by AI",
  "Fair Range": "Fair Range",
  "Total Distance": "Total Distance",
  "How We Calculate Your Fare": "How We Calculate Your Fare",
  "Base Fare": "Base Fare",
  "Calculated based on distance between origin and destination":
    "Calculated based on distance between origin and destination",
  "Fuel Cost Share": "Fuel Cost Share",
  "Share of fuel costs for the trip": "Share of fuel costs for the trip",
  "Toll Cost Share": "Toll Cost Share",
  "Share of toll costs for the route": "Share of toll costs for the route",
  "Driver Service Fee": "Driver Service Fee",
  "Fee for driver services": "Fee for driver services",
  "Car Premium": "Car Premium",
  "Premium for {make} {model}": "Premium for {make} {model}",
  "Feature Premium": "Feature Premium",
  "Additional amenities premium": "Additional amenities premium",
  "Timing Adjustment": "Timing Adjustment",
  "Adjustment based on time of day": "Adjustment based on time of day",
  "Vehicle Type": "Vehicle Type",
  "Premium factor for {make} {model}": "Premium factor for {make} {model}",
  "Comfort Features": "Comfort Features",
  "Additional amenities like AC, Wi-Fi, Premium Sound System":
    "Additional amenities like AC, Wi-Fi, Premium Sound System",
  "Time of Day": "Time of Day",
  "Peak hour pricing factor": "Peak hour pricing factor",
  "Demand Factor": "Demand Factor",
  "Current demand for rides on this route":
    "Current demand for rides on this route",
  High: "High",
  Medium: "Medium",
  Low: "Low",
  "AI Pricing Intelligence": "AI Pricing Intelligence",
  "Our machine learning algorithms analyze real-time data including traffic patterns, historical pricing, vehicle features, and rider preferences to ensure fair and competitive pricing.":
    "Our machine learning algorithms analyze real-time data including traffic patterns, historical pricing, vehicle features, and rider preferences to ensure fair and competitive pricing.",
};
